import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=aff3770c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=aff3770c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff3770c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff3770c')) {
      api.createRecord('aff3770c', component.options)
    } else {
      api.reload('aff3770c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=aff3770c&scoped=true&", function () {
      api.rerender('aff3770c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZoESXrzHaqi/JS/teamMember.vue"
export default component.exports